import * as Hooks from "@olton/hooks";

globalThis.Hooks = Hooks;
